import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d9b0a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top report-div" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  class: "top-list",
  "element-loading-text": "加载中..."
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "检测报告", -1))
const _hoisted_5 = { id: "main" }
const _hoisted_6 = { class: "text-style2" }
const _hoisted_7 = { class: "text-style1" }
const _hoisted_8 = { class: "text-style1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "说明"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 1.检测依据：《华南理工大学毕业论文撰写规范》，《GB7713学位论文编写格式》，《GB7714参考文献著录规则》，《GB15834标点符号用法》，《GB15835出版物上数字用法》，《GB3100国际单位制及其应用》， 《GB3101有关量单位符号的一般原则》，《GB3102空间和时间的量和单位》。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("2.自动检测和人工评阅相比，具有自动，快捷等优点，但目前尚无法完全具备人的智能，存在误报或漏报的可能，请同学们仔细检查！ ")
  ])
], -1))

import { getThesisId } from "@/service/testReport/request.js";
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { downloadHand } from "@/service/common.js";
import { ElMessage } from "element-plus";
import moment from "moment";
import { Split } from "@icon-park/vue-next";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestReport',
  setup(__props) {

const loading = ref(true);
const router = useRouter();
const checkSn = history.state.checkSn;
const resultData = ref([]);
const listData = ref([]); // 论文结果表格数据
const thesisDetail = ref([]); // 论文详情
const testReportDisabled = ref(true); //检测报告按钮状态
const annotateReportDisabled = ref(true); //原文注解报告按钮状态
// 论文信息
const thesisData = reactive({
  thesis_title: "",
  thesis_author: "",
  instructor: "",
  thesis_page: "",
  word_num: "",
  word_cn: "",
  word_en: "",
  question_num: "",
  error_rate: "",
  repair_num: "",
  check_result: "",
  table_path: "",
  annotate_path: "",
  file_type: "",
  template_type: "",
  start_time: "",
  end_time: "",
  total_time: "",
  checkSn: "",
  overtime: "",
  detailErrorNum: "",
  detailWarnNum: "",
});

// 获取论文检测结果
const getThesisResult = async () => {
  const res = await getThesisId(checkSn);
  if (res && res.code && res.code == 200) {
    resultData.value = res.data.thesis_detail;
    thesisData.thesis_title = res.data.thesis.thesisTitle;
    thesisData.thesis_author = res.data.thesis.thesisAuthor;
    thesisData.instructor = res.data.thesis.instructor.includes("[")
      ? JSON.parse(res.data.thesis.instructor.replace(/'/g, '"'))
      : res.data.thesis.instructor;
    thesisData.thesis_page = res.data.thesis.thesisPage;
    thesisData.word_num = res.data.thesis.wordNum;
    thesisData.word_cn = res.data.thesis.wordCn;
    thesisData.word_en = res.data.thesis.wordEn;
    thesisData.question_num = res.data.thesis.questionNum;
    thesisData.detailErrorNum = res.data.thesis.detailErrorNum;
    thesisData.detailWarnNum = res.data.thesis.detailWarnNum;
    thesisData.error_rate = res.data.thesis.errorRate;
    thesisData.repair_num = res.data.thesis.repairNum;
    thesisData.check_result = res.data.thesis.checkResult;
    thesisData.table_path = res.data.thesis.tablePath;
    thesisData.annotate_path = res.data.thesis.annotatePath;
    thesisData.file_type = res.data.thesis.fileType;
    thesisData.template_type = res.data.thesis.templateType;
    thesisData.checkSn = res.data.thesis.checkSn;
    thesisData.overtime = res.data.thesis.overtime;
    thesisDetail.value = res.data.thesis_detail;
    thesisData.start_time = res.data.thesis.startTime
      ? moment(res.data.thesis.startTime).format("YYYY-MM-DD HH:mm:ss")
      : "";
    thesisData.end_time = res.data.thesis.endTime
      ? moment(res.data.thesis.endTime).format("YYYY-MM-DD HH:mm:ss")
      : "";

    let secondTime = moment(thesisData.end_time).diff(
      thesisData.start_time,
      "seconds"
    );
    thesisData.total_time =
      secondTime >= 60 && secondTime % 60 == 0
        ? secondTime / 60 + "分钟"
        : secondTime > 60
        ? Math.trunc(secondTime / 60) + "分" + (secondTime % 60) + "秒"
        : secondTime + "秒";

    if (thesisData.table_path) testReportDisabled.value = false;
    if (thesisData.annotate_path) annotateReportDisabled.value = false;
    // 调用格式化论文结果方法
    thesisDetailFormat();
  } else {
    ElMessage.error(res.msg);
  }
  loading.value = false;
};

// 格式化论文结果
const thesisDetailFormat = () => {
  thesisDetail.value.forEach((item) => {
    if (item.detail !== "") {
      JSON.parse(item.detail).forEach((element) => {
        listData.value.push({
          type: item.label,
          standard: element["1"],
          grade: element["2"],
          result: element["3"],
        });
      });
    }
  });
};

// 表格合并
function objectSpanMethod({ row, column, rowIndex, columnIndex }) {
  if (columnIndex === 0) {
    const _row = flitterData(listData.value).one[rowIndex];
    const _col = _row > 0 ? 1 : 0;
    let arr = flitterData(listData.value).one,
      Nosort = 0;
    for (let i in arr) {
      if (arr[i] > 0) {
        Nosort += 1;
      }
      //为编号赋值，如果_row>0,序号+1，如果_row=0,序号保持不变
      for (let j in listData.value) {
        if (i === j) {
          listData.value[i].sequence = Nosort;
        }
      }
    }

    return {
      rowspan: _row,
      colspan: _col,
    };
  }
  if (columnIndex === 1) {
    const _row = flitterData(listData.value).two[rowIndex];
    const _col = _row > 0 ? 1 : 0;
    return {
      rowspan: _row,
      colspan: _col,
    };
  }
}

function flitterData(arr) {
  let spanOneArr = [],
    spanTwoArr = [],
    concatOne = 0,
    concatTwo = 0;
  arr.forEach((item, index) => {
    if (index === 0) {
      spanOneArr.push(1);
      spanTwoArr.push(1);
    } else {
      if (item.type === arr[index - 1].type) {
        //第一列需合并相同内容的判断条件
        spanOneArr[concatOne] += 1;
        spanOneArr.push(0);
      } else {
        spanOneArr.push(1);
        concatOne = index;
      }
      if (item.type === arr[index - 1].type) {
        //第二列需合并相同内容的判断条件
        spanTwoArr[concatTwo] += 1;
        spanTwoArr.push(0);
      } else {
        spanTwoArr.push(1);
        concatTwo = index;
      }
    }
  });
  return {
    one: spanOneArr,
    two: spanTwoArr,
  };
}

// 下载检测报告
const downloadTestReport = () => {
  let url = "/thesis/downloadReport?checkSn=" + thesisData.checkSn;
  window.open((window as any).apiObj.VUE_APP_BASE_API_URL + url);
};

// 下载原文注解报告
const downloadAnnotateReport = () => {
  if (thesisData.overtime) {
    ElMessage.error("对不起，您尝试下载的报告已过期，报告下载失败");
    return;
  }
  let url =
    "/thesis/downloadReport?checkSn=" + thesisData.checkSn + "&type=annotate";
  window.open((window as any).apiObj.VUE_APP_BASE_API_URL + url);
};

onMounted(async () => {
  document.querySelector(".el-main").scrollTop = 0;
  getThesisResult();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createVNode(_component_el_button, {
                color: "#0054fe",
                size: "large",
                disabled: testReportDisabled.value,
                onClick: downloadTestReport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载检测报告 ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                color: "#0054fe",
                size: "large",
                disabled: annotateReportDisabled.value,
                onClick: downloadAnnotateReport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载原文注解报告 ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createVNode(_component_el_button, {
              size: "",
              color: "#0054fe",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 返回")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_descriptions, {
                title: "论文信息",
                column: 4,
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    span: 2,
                    label: "论文题目",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.thesis_title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "作者",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.thesis_author), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "指导老师",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thesisData.instructor, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: _normalizeClass([thesisData.instructor.length > 1 ? 'mr-10' : '']),
                          key: index
                        }, _toDisplayString(item), 3))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "全文页数",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.thesis_page), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "字数统计",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.word_num), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "中文字符",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.word_cn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "英文字符",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.word_en), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions, {
                title: "检测结果",
                column: 5,
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    label: "检测时间",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.start_time), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "检测用时",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(thesisData.total_time.includes("NaN")
                  ? ""
                  : thesisData.total_time), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "提示数",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(thesisData.detailWarnNum), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "错误数",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(thesisData.detailErrorNum), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "问题项",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(thesisData.question_num), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions, { title: "结果详情" }),
              _createVNode(_component_el_table, {
                data: listData.value,
                border: "",
                style: {"width":"100%","height":"100%"},
                "row-style": { height: '60px' },
                "header-row-style": {
                height: '60px',
              },
                "header-cell-style": {
                background: '#f6f9fe',
                'text-align': 'center',
              },
                "span-method": objectSpanMethod
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    "min-width": "10",
                    align: "center",
                    prop: "sequence"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "类型",
                    "min-width": "20",
                    align: "center",
                    prop: "type"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "standard",
                    "min-width": "",
                    label: "检测标准",
                    align: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "grade",
                    label: "错误级别",
                    "min-width": "15",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.grade == 'error')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createVNode(_component_el_icon, { color: "#D43030" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CircleCloseFilled)
                              ]),
                              _: 1
                            })
                          ]))
                        : (scope.row.grade == 'warning')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _createVNode(_component_el_icon, { color: "#E6A23C" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WarningFilled)
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createVNode(_component_el_icon, { color: "#43B571" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SuccessFilled)
                                ]),
                                _: 1
                              })
                            ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "检测结果",
                    "min-width": "",
                    prop: "result"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createVNode(_component_el_card, {
              "body-style": { background: '#f8f9fb' },
              shadow: "never"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, loading.value]
      ])
    ])
  ]))
}
}

})